import React, { Component } from "react"
import { Table } from "antd"
import { withRouter } from 'react-router-dom'
import overviewIcon from "app/styles/images/sp/overview-selected.svg"

import { observer, inject } from "mobx-react"

@inject("store", 'entrance') @observer
class DataTable extends Component {
  componentDidMount() {
    const { store: { list } } = this.props
    list.getTableData()
      .then(
        res => {
          list.updateTableData(res)
          list.initPageIndex()
        }
      )
  }

  onPaginChange = selectedPageNumber => {
    let {
      store: {
        list
      },
    } = this.props

    list.changePagin(selectedPageNumber)

    document.getElementById("contentTop").scrollIntoView(true)
  }

  renderDataFormat = (record, type) => {
    if (record.data && record.data[type]) {
      const dataCount = record.data[type].dataCount
      const reportCount = record.data[type].reportCount
      let size = record.data[type].size.toFixed(2)
      let downFlow = record.data[type].downFlow.toFixed(2)
      return (
        <div>
          {dataCount + '条 / ' + size + 'GB / ' + downFlow + 'GB/ ' + reportCount + '份'}
        </div>
      )
    } else {
      return '-'
    }
  }

  render() {
    let {
      store: {
        list: {
          tableData,
          totalCount,
          queryMap,
          currentPageIndex,
        },
      }
    } = this.props

    const columns = [
      {
        title: (
          <div className="ta-l">账户</div>
        ),
        width: "20%",
        dataIndex: "username",
        render: (text, record) => {
          return (
            <div>{text}</div>
          )
        }
      },
      {
        title: (
          <div className="ta-l">机构名称</div>
        ),
        width: "20%",
        dataIndex: "orgName",
        render: (text, record) => {
          return (
            <div>{text}</div>
          )
        }
      },
      {
        title: (
          <div className="ta-l">PGS(数据 / 存储 / 下载 / 报告)</div>
        ),
        width: "20%",
        dataIndex: "pgs",
        render: (text, record) => {
          return this.renderDataFormat(record, 'pgs')
        }
      }, {
        title: (
          <div className="ta-l">PGD( 数据 / 存储 / 下载 / 报告)</div>
        ),
        width: "20%",
        dataIndex: "pgd",
        render: (text, record) => {
          return this.renderDataFormat(record, 'pgd')
        }
      }, {
        title: (
          <div className="ta-l">AZF(数据 / 存储 / 下载 / 报告)</div>
        ),
        width: "20%",
        dataIndex: "azf",
        render: (text, record) => {
          return this.renderDataFormat(record, 'azf')
        }
      }
    ]

    return (
      <div>
        <h2 className="page-title"><img alt="" src={overviewIcon} />数据管理</h2>
        <div className="wrapper-box">
          <Table
            className="datamanage-table"
            columns={columns}
            rowKey={record => record.userId + "store"}
            dataSource={tableData.slice()}
            pagination={{
              pageSize: queryMap.limit,
              onChange: this.onPaginChange,
              defaultCurrent: 1,
              current: currentPageIndex,
              total: totalCount,
            }}
          />
        </div>
      </div>
    )
  }
}

export default withRouter(DataTable)



// WEBPACK FOOTER //
// ./src/app/pages/preview/dashboard/containers/DataTable.js